import { aboutProfileContent, metaTagsAbout } from "@/content";
import { AboutProfile } from "@modes0/ui-components";
import Link from "next/link";
import {PageSeo} from "@modes0/ui-components-seo";
import {seoSiteProfile} from "@/content/seo";

export default function AboutPage() {
    return (
        <div className="bg-white">
            <PageSeo meta={metaTagsAbout} siteProfile={seoSiteProfile} includeBusinessSchema />
            <AboutProfile
                {...aboutProfileContent}
                Link={Link}
                headingLevel="h1"
                sectionHeadingLevel="h2"
                className="grow-leads-about-profile"
            />
        </div>
    );
}
